import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import { getTotalAdCostTrend } from '../amazon.services';
import { Grid} from '@mui/material';
import Chart from 'react-google-charts';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import { ALL, GET_AMZ_PRODUCT_URL } from '../../common/constants';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import SearchPanel from '../../../components/search-panel/search-panel.component';

const TotalAdCostTrend = () => {
  const appContext = useContext(AppContext);
  const [trendData, setTrendData] = useState();
  const [searchData, setSearchData] = useState<any>({product: ALL, period: 'Daily', count: 30});
  const options = { legend: {position: 'top', alignment: 'center'}, colors: ["blue", "purple"], 
                    tooltip: { trigger: "none" }, seriesType: "line", series: { 1: { type: "bars" }},
                    chartArea: {left: 50, right: 20, width: '100%'}, vAxes: {0:{viewWindow: { min: 0}}}};

  useEffect(() => {
    getData();
  }, [searchData]);

  function getData() {
    getTotalAdCostTrend(searchData.product, searchData.period, searchData.count, appContext,
      (response: any) => {
        let adData: any = [["Period", "ACOS", { role: "annotation" }, "TACOS", { role: "annotation" }]];
        for(let i = 0; i < response.data.length; ++i) {
          let data: any = [response.data[i][0], +response.data[i][1], response.data[i][1],
                           +response.data[i][2], response.data[i][2]];
          adData.push(data);
        }
        setTrendData(adData);
        appContext.setShowLoader(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  };

  const search = (data: any) => {
    setSearchData(data);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <IDropdown label='Product' url={GET_AMZ_PRODUCT_URL} allItemRequired={true} required={true} name='product' />
        </Grid>
        <Grid item xs={4}>
          <IDropdown label='Period' itemList={['Daily', 'Weekly', 'Monthly']} required={true} name='period' />
        </Grid>
        <Grid item xs={4}>
          <ITextField label='Count' name='count' />
        </Grid>
      </Grid>
    </SearchPanel>
  }

  return <>
    <div style={{ width: '1200px', maxWidth: '100%', margin: '0 auto', boxSizing: 'border-box', padding: '0 8px' }}>
      {getSearchComponent()}
      <Chart chartType="ComboChart" height={"400px"} width="100%" data={trendData} options={options} legendToggle={true}/>
    </div>
  </>
}

export default TotalAdCostTrend;

